<script>
  import Modal, { getModal } from './Modal.svelte';
  import TextesPopup from './TextesPopup.svelte';
  export let displayBloc = '';
  export const txtcgu = `Texte des cgu`;
</script>

<Modal id="newPdc">
  <div class="as-modal-wrapper modal-content">
    <span>
      <div class="as-titre mb-4 text-center" style="z-index:100">
        POLITIQUE DE CONFIDENTIALITÉ
      </div>
      <br />Le traitement des données à caractère personnel résultant de la
      consultation, la navigation et l’utilisation du site internet
      https://www.comptoirtrappe.fr (ci-après désigné le « Site ») et des
      services qu’il propose est régi par la présente politique de
      confidentialité des données.
      <br /><br />SEMIN accorde une grande importance à la protection de votre
      vie privée. C’est pourquoi, dans le cadre de notre politique de
      confidentialité des données, nous souhaitons vous informer :
      <br />des bases légales et des finalités pour lesquelles nous traitons vos
      données personnelles ; et de vos droits et des obligations de notre
      société dans le cadre d’un tel traitement.
      <br />Cette politique de confidentialité des données est distincte de
      notre politique de confidentialité cookies. Pour plus d’informations sur
      la façon dont nous utilisons les cookies et notamment sur les moyens de
      vous opposer à l’installation de ces derniers, vous êtes invité à cliquer
      sur notre lien "Politique de confidentialité des cookies".
      <br /><br /><br />

      <strong>Nature de la collecte des données à caractère personnel</strong>
      <br />Dans le cadre de l’utilisation du Site et des services qu’il
      propose, vous pouvez être amené à fournir à notre société, en sa qualité
      de responsable de traitement, des données à caractère personnel vous
      concernant. Certaines données personnelles sont obligatoires, d’autres
      facultatives, pour accéder ou bénéficier de certains services présents sur
      le Site, tels que les formulaires de contact. Le caractère obligatoire ou
      facultatif des données est signalé lors de la collecte. En l’absence de
      communication des données personnelles obligatoires, notre société ne
      pourra pas répondre à votre demande. <br />
      <br />Les catégories de données concernées sont les suivantes :
      <br />&bull; nom ;
      <br />&bull; prénom ;
      <br />&bull; adresse postale ;
      <br />&bull; pays ;
      <br />&bull; courrier électronique ;
      <br />&bull; coordonnées téléphoniques ;
      <br />&bull; fonctions ;
      <br />&bull; société ;
      <br /><br /><br />

      <strong>Bases légales et Finalité du Traitement</strong>
      <br />SEMIN n’est pas autorisé à traiter des données personnelles si nous
      ne disposons pas d’une base juridique pour le faire. Par conséquent, nous
      ne traitons vos données personnelles que si (i) nous avons obtenu votre
      consentement préalable, (ii) le traitement est nécessaire à la fourniture
      des services que nous vous proposons ou bien (iii) le traitement est
      nécessaire à la satisfaction des intérêts légitimes de notre société, en
      notre qualité de responsable de traitement.
      <br />
      <br />
      La collecte, le stockage et le traitement des données personnelles ont principalement
      pour finalité :
      <br />&bull; de gérer et d’améliorer les relations entre notre société et
      vous ;
      <br />&bull; de permettre le fonctionnement du Site ;
      <br />&bull; de répondre à vos demandes ;
      <br />&bull; de vous adresser nos publications, communiqués et
      informations et notamment notre newsletter ;
      <br />&bull; de nous permettre d’examiner les candidatures ;
      <br />&bull; de nous permettre de respecter les obligations légales et
      réglementaires qui nous incombent, en particulier en matière de sécurité ;
      <br />&bull; de communiquer ou permettre l’accès par des tiers dans le
      cadre d’un éventuel projet de vente, fusion et/ou restructuration ;
      <br /><br /><br />

      <strong>Destinataire(s) des Données Personnelles</strong>
      <br />Vos données personnelles ne seront pas transmises ou rendues
      accessibles à des tiers, sous réserve des membres habilités du personnel
      de notre société et de nos prestataires (tels que les fournisseurs de
      systèmes informatiques, les hébergeurs, les consultants), étant précisé
      que chacun de ces prestataires de services est soumis à des obligations
      strictes de protection des données et de confidentialité.
      <br /><br />Par ailleurs, en cas d’infraction avérée à des dispositions
      légales ou réglementaires, ces données pourront faire l’objet d’une
      communication sur demande expresse et motivée des autorités judiciaires.
      <br /><br />Nous pouvons partager vos données personnelles, dans la mesure
      du possible de manière occultée, avec d’autres tiers, par exemple dans le
      cadre d’une éventuelle vente, fusion et/ou restructuration de
      l’entreprise, et ce, uniquement pour les besoins de l’opération ainsi que
      dans le cadre d’une obligation de confidentialité. En cas de violation de
      données personnelles, nous vous en informerons, ainsi que l’autorité de
      contrôle compétente tel que requis par la loi applicable.
      <br /><br /><br />

      <strong>Durée de conservation des données personnelles</strong>
      <br />Vos données personnelles ne seront conservées que pendant la période
      nécessaire pour atteindre les objectifs pour lesquels ces données ont été
      traitées ou pour se conformer aux exigences légales ou réglementaires.
      <br /><br />Vos données personnelles seront, en particulier, conservées
      pendant la durée de la relation commerciale et, au-delà, à des fins
      promotionnelles, à des fins de preuve et pour satisfaire à des obligations
      comptables, pendant une période n’excédant pas les délais légaux de
      prescription.
      <br /><br /><br />
      <strong>Sécurité</strong>
      <br />SEMIN a mis en place des mesures techniques et organisationnelles
      afin de protéger vos données personnelles contre la destruction non
      autorisée, accidentelle ou illicite, la perte, l’altération, la mauvaise
      utilisation ou encore la divulgation non autorisée des données
      personnelles vous concernant. Ces mesures assurent un niveau de sécurité
      approprié des données et tiennent compte de l’état des connaissances, des
      coûts de mise en œuvre par rapport aux risques et de la nature des données
      à protéger.
      <br /><br />Notre société garantit par ailleurs que les membres de son
      personnel amenés à traiter les données personnelles vous concernant
      respectent les règles et procédures internes relatives au traitement des
      données personnelles et notamment les mesures de sécurité techniques et
      organisationnelles mises en place pour protéger vos données personnelles.
      <br /><br /><br />
      <strong>Exercice des droits</strong>
      <br />Conformément à la règlementation relative à la protection des
      données personnelles, vous disposez d’un droit d’accès, de rectification,
      de suppression, le cas échéant de limitation et de portabilité de vos
      données personnelles ainsi que d’un droit d’opposition à leur traitement.
      Vous avez également le droit de retirer votre consentement au traitement
      de vos données personnelles (sans que ce retrait n’affecte toutefois la
      licéité des traitements réalisés antérieurement). Vous disposez en outre
      du droit de définir des directives relatives au sort de vos données en cas
      de décès
      <br />
      <br /> Au besoin, vous bénéficiez du droit d’introduire une réclamation
      auprès de l’autorité de protection des données de l’Etat membre dans
      lequel vous résidez.
      <br /><br />Ces droits peuvent être exercés directement auprès de notre
      société en vous adressant à l’adresse suivante : privacy@semin.com.
      <br /><br />Pour des raisons de sécurité et afin d’éviter toute demande
      frauduleuse, nous pourrons être amenés à vous demander de fournir un
      justificatif d’identité à l’appui de votre requête. Après traitement de la
      demande, ce justificatif sera détruit.
      <br /><br /><br />
      <strong>Transfert de données hors Union Européenne</strong>
      <br />Certains de nos partenaires/prestataires pouvant être situés en
      dehors de l’Union Européenne, les données ainsi collectées peuvent faire
      l’objet d’un transfert vers des pays non-membres de l’Union Européenne,
      dont la législation en matière de protection des données personnelles
      diffère de celle de l’Union Européenne, étant précisé que, dans
      l’hypothèse où le ou les pays destinataires n’assureraient pas un niveau
      de protection des données équivalent à celui de l’Union Européenne, notre
      société s’engage à prendre toutes les garanties nécessaires, soit sur la
      base d’une décision d’adéquation soit, en l’absence d’une telle décision,
      sur la base de garanties appropriées telles que des règles internes
      contraignantes, des clauses contractuelles types adoptées par la
      Commission européenne, un code de conduite ou un mécanisme de
      certification dûment approuvés par l’autorité compétente, et dont la
      communication peut être obtenue en envoyant un mail à l’adresse suivante :
      privacy@semin.com.
      <br /><br /><br />
      <strong>Coordonnées</strong>
      <br />Si vous avez des questions relatives à cette politique de
      confidentialité des données, vous pouvez nous contacter à l’adresse
      suivante : privacy@semin.com.
      <br />
    </span>
  </div>
</Modal>

<Modal id="newPdcc">
  <div class="as-modal-wrapper modal-content">
    <span>
      <div class="as-titre mb-4 text-center" style="z-index:100">
        POLITIQUE DE CONFIDENTIALITÉ COOKIES
      </div>
      <br />La navigation sur le site https://www.comptoirtrappes.fr (ci-après
      désigné le « Site ») est susceptible de provoquer l’installation de
      cookie(s) sur votre terminal. Un cookie est un fichier de petite taille,
      qui ne permet pas votre identification, mais qui enregistre des
      informations relatives à la navigation d’un terminal sur un site. Les
      données ainsi obtenues visent à faciliter la navigation ultérieure sur le
      Site, et ont également vocation à permettre diverses mesures de
      fréquentation.
      <br />Vous avez la possibilité de configurer les terminaux pour qu’ils
      acceptent tous les cookies, qu’ils vous informent lorsqu’un cookie est
      émis ou qu’ils n’acceptent jamais aucun cookie. Cette dernière option
      signifie que certains services personnalisés peuvent ne pas vous être
      fournis et, en conséquence, que vous risquez de ne pas être en mesure de
      profiter pleinement de toutes les fonctions offertes par le Site.<br /><br
      />

      Les cookies ne causent aucun dommage au terminal, mais permettent plus
      facilement par exemple de retrouver les préférences, de pré-remplir
      certains champs et d’adapter le contenu des services du site consulté. Ces
      données permettent l’amélioration de l’ergonomie et des services en
      fonction de vos intérêts.<br /><br />

      <strong>Comment accepter ou refuser l’utilisation des cookies ?</strong
      ><br />
      Si vous ne souhaitez pas recevoir de cookies de manière générale ou souhaitez
      refuser uniquement certains cookies, il vous est possible de modifier les paramètres
      de votre navigateur de manière appropriée.
      <br />Des instructions sont fournies à cet effet sur le site internet de
      chaque navigateur :
      <br /><strong>Pour Internet Explorer :</strong>
      <br /><a
        href="https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies"
        target="_blank"
        >https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies</a
      >
      <br /><strong>Pour Firefox :</strong>
      <br /><a
        href="https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies"
        target="_blank"
        >https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies</a
      >
      <br /><strong>Pour Safari :</strong>
      <br /><a
        href="https://support.apple.com/kb/ht1677?viewlocale=fr_FR"
        target="_blank">https://support.apple.com/kb/ht1677?viewlocale=fr_FR</a
      >
      <br /><strong>Pour Chrome :</strong>
      <br /><a
        href="https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647"
        target="_blank"
        >https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647</a
      >
      <br /><br /><br />
      <strong>Comment utilisons-nous les cookies ?</strong>
      <br />Les informations recueillies à l’aide des cookies permettent
      d’analyser l’utilisation du Site et ainsi de vous offrir une meilleure
      expérience utilisateur lors de votre visite du Site. Les informations
      recueillies par ces cookies ne servent ni à vous identifier, ni à vous
      envoyer des messages publicitaires par e-mail ou par courrier postal.

      <br /><br /><strong
        >Quels types de cookies utilisons-nous et à quelles fins ?</strong
      >
      <br /><br />
      <span class="title3">Cookies nécessaires d’un point de vue technique</span
      >
      <br /> Quelques-uns des cookies sont strictement nécessaires à
      l’utilisation du Site ou de certaines de ses fonctionnalités, comme
      permettre le choix de la langue utilisée. Lorsque vous utilisez ce Site,
      ces cookies fonctionnels ne peuvent être refusés.
      <br /><br />
      <span class="title3">Cookies de session et cookies de préférences</span>
      <br />Notre Site peut être amené à utiliser des cookies de session afin de
      permettre exclusivement la transmission d’une communication nécessaire au
      fonctionnement du Site. Ces cookies expirent à la fin de votre session
      (c’est-à-dire lorsque vous fermez la fenêtre du navigateur). Le cas
      échéant, et uniquement si vous l’acceptez en cliquant sur le bouton «
      Accepter » prévu à cet effet en tant que de besoin, le Site serait aussi
      susceptible d’utiliser des cookies qui sont conservés plus longtemps afin
      de mémoriser vos préférences et vos choix sur le Site. Ces cookies auront
      une durée de vie ne pouvant pas excéder treize mois.
      <br /><br />
      <span class="title3">Cookies analytiques</span>
      <br />Notre Site peut utiliser des cookies analytiques afin d’améliorer sa
      performance, en recueillant uniquement les données de connexion relatives
      à la date, l’heure, l’adresse Internet, le protocole du terminal ainsi que
      la page consultée. Nous ne cédons aucune de ces données à des tiers, ne
      les réutilisons pas pour d’autres finalités, ne les recoupons pas avec
      d’autres traitements y compris de fichiers clients, et ne les conservons
      en aucune manière pour une durée supérieure à six mois.
      <br />En tout état de cause, il se peut que notre Site utilise les outils
      analytiques de Google Analytics et les cookies qui y sont associés. Bien
      que nous n’ayons aucun contrôle sur de tels fournisseurs d’outils
      analytiques ou d’autres fournisseurs qui sont responsables de leurs
      propres traitements, pas plus que sur les données qu’ils recueillent y
      compris dans le cadre d’un transfert de données hors de l’Union européenne
      dès lors que certains d’entre eux sont notamment situés aux Etats- Unis,
      nous avons jugé indispensable d’en faire mention afin que vous disposiez
      d’une information claire et complète du fait que leur utilisation peut, le
      cas échéant, nécessiter que vous donniez votre consentement.
      <br />Pour obtenir des informations supplémentaires, et sous réserve de la
      disponibilité de ces informations en langue française, vous pouvez vous
      reporter au site suivant : cliquez ici pour consulter la politique de
      confidentialité de Google Analytics.
      <br />Vous pouvez toutefois vous opposer à ces différentes opérations en
      configurant votre navigateur, tel qu’Internet Explorer ou Firefox, en
      suivant les instructions, indiquées ci-dessus, qui vous sont fournies à
      cet effet sur le site Internet de votre navigateur. En cas d’exercice de
      votre droit d’opposition, nous vous confirmons qu’aucune donnée de
      connexion ne sera transmise à un quelconque fournisseur d’outils d’analyse
      d’audience.
      <br />Vous disposez également d’un droit d’accès aux données vous
      concernant que vous pouvez exercer en contactant le fournisseur concerné,
      en précisant le numéro identifiant du cookie.
      <br />
      <br />
      <span class="title3">Cookies tiers</span>
      <br />Notre Site intègre des fonctionnalités provenant de sites tiers,
      notamment de certains réseaux sociaux. Ces fonctionnalités peuvent parfois
      être accompagnées de scripts ou d’autres éléments capables de lire et
      parfois de placer des cookies provenant de ces réseaux sociaux sur votre
      appareil. Ces cookies peuvent servir à personnaliser des messages
      publicitaires. Bien que nous n’ayons aucun accès à ces cookies, ni aucun
      contrôle sur ces réseaux sociaux qui sont responsables de leurs propres
      traitements, pas plus qu’aux données qu’ils recueillent y compris dans le
      cadre
      <br />
      <br /> d’un transfert de données hors de l’Union Européenne dès lors que
      certains d’entre eux sont notamment situés aux Etats-Unis, nous jugeons
      indispensable d’en faire mention afin que vous disposiez d’une information
      claire et complète du fait que leur utilisation peut, le cas échéant,
      nécessiter votre consentement. Pour obtenir des informations
      supplémentaires, et sous réserve de la disponibilité de ces informations
      en langue française, il est possible de se reporter à la liste des cookies
      de réseaux sociaux potentiels ci-dessous.

      <br /><br />
      <strong>Facebook.</strong>
      <a
        href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Facebook
      </a><br />
      <a href="https://www.facebook.com/policies/cookies/" target="_blank">
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Facebook
      </a>
      <br /><br />
      <strong> Twitter.</strong>
      <a
        href="https://cdn.cms-twdigitalassets.com/content/dam/legal-twitter/site-assets/privacy-page-gdpr/pdfs/PP_Q22018_April_FR.pdf"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Twitter
      </a><br />
      <a
        href="https://help.twitter.com/fr/rules-and-policies/twitter-cookies"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Twitter
      </a>
      <br /><br />
      <strong> YouTube.</strong>
      <a href="https://policies.google.com/privacy?hl=fr" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité de YouTube
      </a><br />
      <a
        href="https://policies.google.com/technologies/cookies?hl=fr"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        YouTube
      </a>
      <br /><br />
      <strong> Google.</strong>
      <a href="https://policies.google.com/?hl=fr" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité Google
      </a><br />
      <a
        href="https://policies.google.com/technologies/cookies?hl=fr"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Google
      </a>
      <br /><br />
      <strong>Linkedin.</strong>
      <a
        href="https://www.linkedin.com/legal/privacy-policy?_l=fr_FR"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Linkedin
      </a><br />
      <a href="https://www.linkedin.com/legal/cookie-policy" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité cookies de
        Linkedin
      </a>
      <br />
    </span>
  </div>
</Modal>

<span>
  {#if displayBloc == 'mentions'}
    <span>
      <div class="as-titre mb-4 text-center" style="z-index:100">
        Mentions légales
      </div>
      <br />Conformément aux dispositions des Articles 6-III et 19 de la Loi
      n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique,
      dite L.C.E.N., il est porté à la connaissance des utilisateurs et
      visiteurs, ci-après l""Utilisateur", du site semin.fr , ci-après le
      "Site", les présentes mentions légales.
      <br />
      <br />La connexion et la navigation sur le Site par l’Utilisateur implique
      acceptation intégrale et sans réserve des présentes mentions légales.
      <br />
      <br />Ces dernières sont accessibles sur le Site à la rubrique « Mentions
      légales ».
      <br />
      <br /><strong>ARTICLE 1 - L'EDITEUR</strong>
      <br />
      <br />L'édition du Site est assurée par SEMIN SAS au capital de 2000592,00
      euros, immatriculée au Registre du Commerce et des Sociétés de Thionville
      sous le numéro 300398880 dont le siège social est situé au 1a, rue de la
      Gare,
      <br />Numéro de téléphone 330382835357,
      <br />Adresse e-mail : mail@semin.com.
      <br />N° de TVA intracommunautaire : TVA FR 13 300 398 880
      <br />Le Directeur de la publication est Philippe Semin
      <br />ci-après l'"<strong>Editeur</strong>".
      <br />
      <br /><strong>ARTICLE 2 - CONCEPTION</strong>
      <br />
      <br />Ccnception et réalisation par la société AYMAZING, dont le siège
      social est situé au 27 rue de Maubeuge, 75009 Paris
      <br />www.aymazing.fr
      <br />
      <br /><strong>ARTICLE 3 - L'HEBERGEUR</strong>
      <br />
      <br />L'hébergeur du Site est la société Domaine Achant, dont le siège
      social est situé au 9 place de la Libération, 26111 Nyons cedx
      <br />Téléphone : 04 75 26 20 52
      <br />www.domaine-achat.fr
      <br />
      <br /><strong>ARTICLE 4 - ACCES AU SITE</strong>
      <br />
      <br />Le Site est accessible en tout endroit, 7j/7, 24h/24 sauf cas de
      force majeure, interruption programmée ou non et pouvant découlant d’une
      nécessité de maintenance.
      <br />
      <br />En cas de modification, interruption ou suspension du Site,
      l'Editeur ne saurait être tenu responsable.
      <br />
      <br /><strong>ARTICLE 5 - COLLECTE DES DONNEES</strong>
      <br />
      <br />Le Site assure à l'Utilisateur une collecte et un traitement
      d'informations personnelles dans le respect de la vie privée conformément
      à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers
      et aux libertés.
      <br />
      <br />En vertu de la loi Informatique et Libertés, en date du 6 janvier
      1978, l'Utilisateur dispose d'un droit d'accès, de rectification, de
      suppression et d'opposition de ses données personnelles. L'Utilisateur
      exerce ce droit :
      <br />· par mail à l'adresse email privacy@semin.com
      <br />
      <br />Toute utilisation, reproduction, diffusion, commercialisation,
      modification de toute ou partie du Site, sans autorisation de l’Editeur
      est prohibée et pourra entraînée des actions et poursuites judiciaires
      telles que notamment prévues par le Code de la propriété intellectuelle et
      le Code civil.
      <br />
      <br />Pour plus d'informations en matière de protection des données à
      caractère personnel , se reporter à la Charte en matière de protection des
      données à caractère personnel du site semin.fr accessible à la rubrique "<span
        class="asLinkPdc"
        on:click="{() => getModal('newPdc').open()}"
        >Politique de confidentialité</span
      >".
      <br />
      <br />
    </span>
  {:else if displayBloc == 'pdc'}
    <span>
      <div class="as-titre mb-4 text-center" style="z-index:100">
        POLITIQUE DE CONFIDENTIALITÉ
      </div>
      <br />Le traitement des données à caractère personnel résultant de la
      consultation, la navigation et l’utilisation du site internet
      https://www.comptoirtrappe.fr (ci-après désigné le « Site ») et des
      services qu’il propose est régi par la présente politique de
      confidentialité des données.
      <br /><br />SEMIN accorde une grande importance à la protection de votre
      vie privée. C’est pourquoi, dans le cadre de notre politique de
      confidentialité des données, nous souhaitons vous informer :
      <br />des bases légales et des finalités pour lesquelles nous traitons vos
      données personnelles ; et de vos droits et des obligations de notre
      société dans le cadre d’un tel traitement.
      <br />Cette politique de confidentialité des données est distincte de
      notre politique de confidentialité cookies. Pour plus d’informations sur
      la façon dont nous utilisons les cookies et notamment sur les moyens de
      vous opposer à l’installation de ces derniers, vous êtes invité à cliquer
      sur notre lien "<span
        class="asLinkPdc"
        on:click="{() => getModal('newPdcc').open()}"
        >Politique de confidentialité des cookies</span
      >".
      <br /><br /><br />

      <strong>Nature de la collecte des données à caractère personnel</strong>
      <br />Dans le cadre de l’utilisation du Site et des services qu’il
      propose, vous pouvez être amené à fournir à notre société, en sa qualité
      de responsable de traitement, des données à caractère personnel vous
      concernant. Certaines données personnelles sont obligatoires, d’autres
      facultatives, pour accéder ou bénéficier de certains services présents sur
      le Site, tels que les formulaires de contact. Le caractère obligatoire ou
      facultatif des données est signalé lors de la collecte. En l’absence de
      communication des données personnelles obligatoires, notre société ne
      pourra pas répondre à votre demande. <br />
      <br />Les catégories de données concernées sont les suivantes :
      <br />&bull; nom ;
      <br />&bull; prénom ;
      <br />&bull; adresse postale ;
      <br />&bull; pays ;
      <br />&bull; courrier électronique ;
      <br />&bull; coordonnées téléphoniques ;
      <br />&bull; fonctions ;
      <br />&bull; société ;
      <br /><br /><br />

      <strong>Bases légales et Finalité du Traitement</strong>
      <br />SEMIN n’est pas autorisé à traiter des données personnelles si nous
      ne disposons pas d’une base juridique pour le faire. Par conséquent, nous
      ne traitons vos données personnelles que si (i) nous avons obtenu votre
      consentement préalable, (ii) le traitement est nécessaire à la fourniture
      des services que nous vous proposons ou bien (iii) le traitement est
      nécessaire à la satisfaction des intérêts légitimes de notre société, en
      notre qualité de responsable de traitement.
      <br />
      <br />
      La collecte, le stockage et le traitement des données personnelles ont principalement
      pour finalité :
      <br />&bull; de gérer et d’améliorer les relations entre notre société et
      vous ;
      <br />&bull; de permettre le fonctionnement du Site ;
      <br />&bull; de répondre à vos demandes ;
      <br />&bull; de vous adresser nos publications, communiqués et
      informations et notamment notre newsletter ;
      <br />&bull; de nous permettre d’examiner les candidatures ;
      <br />&bull; de nous permettre de respecter les obligations légales et
      réglementaires qui nous incombent, en particulier en matière de sécurité ;
      <br />&bull; de communiquer ou permettre l’accès par des tiers dans le
      cadre d’un éventuel projet de vente, fusion et/ou restructuration ;
      <br /><br /><br />

      <strong>Destinataire(s) des Données Personnelles</strong>
      <br />Vos données personnelles ne seront pas transmises ou rendues
      accessibles à des tiers, sous réserve des membres habilités du personnel
      de notre société et de nos prestataires (tels que les fournisseurs de
      systèmes informatiques, les hébergeurs, les consultants), étant précisé
      que chacun de ces prestataires de services est soumis à des obligations
      strictes de protection des données et de confidentialité.
      <br /><br />Par ailleurs, en cas d’infraction avérée à des dispositions
      légales ou réglementaires, ces données pourront faire l’objet d’une
      communication sur demande expresse et motivée des autorités judiciaires.
      <br /><br />Nous pouvons partager vos données personnelles, dans la mesure
      du possible de manière occultée, avec d’autres tiers, par exemple dans le
      cadre d’une éventuelle vente, fusion et/ou restructuration de
      l’entreprise, et ce, uniquement pour les besoins de l’opération ainsi que
      dans le cadre d’une obligation de confidentialité. En cas de violation de
      données personnelles, nous vous en informerons, ainsi que l’autorité de
      contrôle compétente tel que requis par la loi applicable.
      <br /><br /><br />

      <strong>Durée de conservation des données personnelles</strong>
      <br />Vos données personnelles ne seront conservées que pendant la période
      nécessaire pour atteindre les objectifs pour lesquels ces données ont été
      traitées ou pour se conformer aux exigences légales ou réglementaires.
      <br /><br />Vos données personnelles seront, en particulier, conservées
      pendant la durée de la relation commerciale et, au-delà, à des fins
      promotionnelles, à des fins de preuve et pour satisfaire à des obligations
      comptables, pendant une période n’excédant pas les délais légaux de
      prescription.
      <br /><br /><br />
      <strong>Sécurité</strong>
      <br />SEMIN a mis en place des mesures techniques et organisationnelles
      afin de protéger vos données personnelles contre la destruction non
      autorisée, accidentelle ou illicite, la perte, l’altération, la mauvaise
      utilisation ou encore la divulgation non autorisée des données
      personnelles vous concernant. Ces mesures assurent un niveau de sécurité
      approprié des données et tiennent compte de l’état des connaissances, des
      coûts de mise en œuvre par rapport aux risques et de la nature des données
      à protéger.
      <br /><br />Notre société garantit par ailleurs que les membres de son
      personnel amenés à traiter les données personnelles vous concernant
      respectent les règles et procédures internes relatives au traitement des
      données personnelles et notamment les mesures de sécurité techniques et
      organisationnelles mises en place pour protéger vos données personnelles.
      <br /><br /><br />
      <strong>Exercice des droits</strong>
      <br />Conformément à la règlementation relative à la protection des
      données personnelles, vous disposez d’un droit d’accès, de rectification,
      de suppression, le cas échéant de limitation et de portabilité de vos
      données personnelles ainsi que d’un droit d’opposition à leur traitement.
      Vous avez également le droit de retirer votre consentement au traitement
      de vos données personnelles (sans que ce retrait n’affecte toutefois la
      licéité des traitements réalisés antérieurement). Vous disposez en outre
      du droit de définir des directives relatives au sort de vos données en cas
      de décès
      <br />
      <br /> Au besoin, vous bénéficiez du droit d’introduire une réclamation
      auprès de l’autorité de protection des données de l’Etat membre dans
      lequel vous résidez.
      <br /><br />Ces droits peuvent être exercés directement auprès de notre
      société en vous adressant à l’adresse suivante : privacy@semin.com.
      <br /><br />Pour des raisons de sécurité et afin d’éviter toute demande
      frauduleuse, nous pourrons être amenés à vous demander de fournir un
      justificatif d’identité à l’appui de votre requête. Après traitement de la
      demande, ce justificatif sera détruit.
      <br /><br /><br />
      <strong>Transfert de données hors Union Européenne</strong>
      <br />Certains de nos partenaires/prestataires pouvant être situés en
      dehors de l’Union Européenne, les données ainsi collectées peuvent faire
      l’objet d’un transfert vers des pays non-membres de l’Union Européenne,
      dont la législation en matière de protection des données personnelles
      diffère de celle de l’Union Européenne, étant précisé que, dans
      l’hypothèse où le ou les pays destinataires n’assureraient pas un niveau
      de protection des données équivalent à celui de l’Union Européenne, notre
      société s’engage à prendre toutes les garanties nécessaires, soit sur la
      base d’une décision d’adéquation soit, en l’absence d’une telle décision,
      sur la base de garanties appropriées telles que des règles internes
      contraignantes, des clauses contractuelles types adoptées par la
      Commission européenne, un code de conduite ou un mécanisme de
      certification dûment approuvés par l’autorité compétente, et dont la
      communication peut être obtenue en envoyant un mail à l’adresse suivante :
      privacy@semin.com.
      <br /><br /><br />
      <strong>Coordonnées</strong>
      <br />Si vous avez des questions relatives à cette politique de
      confidentialité des données, vous pouvez nous contacter à l’adresse
      suivante : privacy@semin.com.
      <br />
    </span>
  {:else if displayBloc == 'pdcc'}
    <span>
      <div class="as-titre mb-4 text-center" style="z-index:100">
        POLITIQUE DE CONFIDENTIALITÉ COOKIES
      </div>
      <br />La navigation sur le site https://www.comptoirtrappes.fr (ci-après
      désigné le « Site ») est susceptible de provoquer l’installation de
      cookie(s) sur votre terminal. Un cookie est un fichier de petite taille,
      qui ne permet pas votre identification, mais qui enregistre des
      informations relatives à la navigation d’un terminal sur un site. Les
      données ainsi obtenues visent à faciliter la navigation ultérieure sur le
      Site, et ont également vocation à permettre diverses mesures de
      fréquentation.
      <br />Vous avez la possibilité de configurer les terminaux pour qu’ils
      acceptent tous les cookies, qu’ils vous informent lorsqu’un cookie est
      émis ou qu’ils n’acceptent jamais aucun cookie. Cette dernière option
      signifie que certains services personnalisés peuvent ne pas vous être
      fournis et, en conséquence, que vous risquez de ne pas être en mesure de
      profiter pleinement de toutes les fonctions offertes par le Site.<br /><br
      />

      Les cookies ne causent aucun dommage au terminal, mais permettent plus
      facilement par exemple de retrouver les préférences, de pré-remplir
      certains champs et d’adapter le contenu des services du site consulté. Ces
      données permettent l’amélioration de l’ergonomie et des services en
      fonction de vos intérêts.<br /><br />

      <strong>Comment accepter ou refuser l’utilisation des cookies ?</strong
      ><br />
      Si vous ne souhaitez pas recevoir de cookies de manière générale ou souhaitez
      refuser uniquement certains cookies, il vous est possible de modifier les paramètres
      de votre navigateur de manière appropriée.
      <br />Des instructions sont fournies à cet effet sur le site internet de
      chaque navigateur :
      <br /><strong>Pour Internet Explorer :</strong>
      <br /><a
        href="https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies"
        target="_blank"
        >https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies</a
      >
      <br /><strong>Pour Firefox :</strong>
      <br /><a
        href="https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies"
        target="_blank"
        >https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies</a
      >
      <br /><strong>Pour Safari :</strong>
      <br /><a
        href="https://support.apple.com/kb/ht1677?viewlocale=fr_FR"
        target="_blank">https://support.apple.com/kb/ht1677?viewlocale=fr_FR</a
      >
      <br /><strong>Pour Chrome :</strong>
      <br /><a
        href="https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647"
        target="_blank"
        >https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647</a
      >
      <br /><br /><br />
      <strong>Comment utilisons-nous les cookies ?</strong>
      <br />Les informations recueillies à l’aide des cookies permettent
      d’analyser l’utilisation du Site et ainsi de vous offrir une meilleure
      expérience utilisateur lors de votre visite du Site. Les informations
      recueillies par ces cookies ne servent ni à vous identifier, ni à vous
      envoyer des messages publicitaires par e-mail ou par courrier postal.

      <br /><br /><strong
        >Quels types de cookies utilisons-nous et à quelles fins ?</strong
      >
      <br /><br />
      <span class="title3">Cookies nécessaires d’un point de vue technique</span
      >
      <br /> Quelques-uns des cookies sont strictement nécessaires à
      l’utilisation du Site ou de certaines de ses fonctionnalités, comme
      permettre le choix de la langue utilisée. Lorsque vous utilisez ce Site,
      ces cookies fonctionnels ne peuvent être refusés.
      <br /><br />
      <span class="title3">Cookies de session et cookies de préférences</span>
      <br />Notre Site peut être amené à utiliser des cookies de session afin de
      permettre exclusivement la transmission d’une communication nécessaire au
      fonctionnement du Site. Ces cookies expirent à la fin de votre session
      (c’est-à-dire lorsque vous fermez la fenêtre du navigateur). Le cas
      échéant, et uniquement si vous l’acceptez en cliquant sur le bouton «
      Accepter » prévu à cet effet en tant que de besoin, le Site serait aussi
      susceptible d’utiliser des cookies qui sont conservés plus longtemps afin
      de mémoriser vos préférences et vos choix sur le Site. Ces cookies auront
      une durée de vie ne pouvant pas excéder treize mois.
      <br /><br />
      <span class="title3">Cookies analytiques</span>
      <br />Notre Site peut utiliser des cookies analytiques afin d’améliorer sa
      performance, en recueillant uniquement les données de connexion relatives
      à la date, l’heure, l’adresse Internet, le protocole du terminal ainsi que
      la page consultée. Nous ne cédons aucune de ces données à des tiers, ne
      les réutilisons pas pour d’autres finalités, ne les recoupons pas avec
      d’autres traitements y compris de fichiers clients, et ne les conservons
      en aucune manière pour une durée supérieure à six mois.
      <br />En tout état de cause, il se peut que notre Site utilise les outils
      analytiques de Google Analytics et les cookies qui y sont associés. Bien
      que nous n’ayons aucun contrôle sur de tels fournisseurs d’outils
      analytiques ou d’autres fournisseurs qui sont responsables de leurs
      propres traitements, pas plus que sur les données qu’ils recueillent y
      compris dans le cadre d’un transfert de données hors de l’Union européenne
      dès lors que certains d’entre eux sont notamment situés aux Etats- Unis,
      nous avons jugé indispensable d’en faire mention afin que vous disposiez
      d’une information claire et complète du fait que leur utilisation peut, le
      cas échéant, nécessiter que vous donniez votre consentement.
      <br />Pour obtenir des informations supplémentaires, et sous réserve de la
      disponibilité de ces informations en langue française, vous pouvez vous
      reporter au site suivant : cliquez ici pour consulter la politique de
      confidentialité de Google Analytics.
      <br />Vous pouvez toutefois vous opposer à ces différentes opérations en
      configurant votre navigateur, tel qu’Internet Explorer ou Firefox, en
      suivant les instructions, indiquées ci-dessus, qui vous sont fournies à
      cet effet sur le site Internet de votre navigateur. En cas d’exercice de
      votre droit d’opposition, nous vous confirmons qu’aucune donnée de
      connexion ne sera transmise à un quelconque fournisseur d’outils d’analyse
      d’audience.
      <br />Vous disposez également d’un droit d’accès aux données vous
      concernant que vous pouvez exercer en contactant le fournisseur concerné,
      en précisant le numéro identifiant du cookie.
      <br />
      <br />
      <span class="title3">Cookies tiers</span>
      <br />Notre Site intègre des fonctionnalités provenant de sites tiers,
      notamment de certains réseaux sociaux. Ces fonctionnalités peuvent parfois
      être accompagnées de scripts ou d’autres éléments capables de lire et
      parfois de placer des cookies provenant de ces réseaux sociaux sur votre
      appareil. Ces cookies peuvent servir à personnaliser des messages
      publicitaires. Bien que nous n’ayons aucun accès à ces cookies, ni aucun
      contrôle sur ces réseaux sociaux qui sont responsables de leurs propres
      traitements, pas plus qu’aux données qu’ils recueillent y compris dans le
      cadre
      <br />
      <br /> d’un transfert de données hors de l’Union Européenne dès lors que
      certains d’entre eux sont notamment situés aux Etats-Unis, nous jugeons
      indispensable d’en faire mention afin que vous disposiez d’une information
      claire et complète du fait que leur utilisation peut, le cas échéant,
      nécessiter votre consentement. Pour obtenir des informations
      supplémentaires, et sous réserve de la disponibilité de ces informations
      en langue française, il est possible de se reporter à la liste des cookies
      de réseaux sociaux potentiels ci-dessous.

      <br /><br />
      <strong>Facebook.</strong>
      <a
        href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Facebook
      </a><br />
      <a href="https://www.facebook.com/policies/cookies/" target="_blank">
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Facebook
      </a>
      <br /><br />
      <strong> Twitter.</strong>
      <a
        href="https://cdn.cms-twdigitalassets.com/content/dam/legal-twitter/site-assets/privacy-page-gdpr/pdfs/PP_Q22018_April_FR.pdf"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Twitter
      </a><br />
      <a
        href="https://help.twitter.com/fr/rules-and-policies/twitter-cookies"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Twitter
      </a>
      <br /><br />
      <strong> YouTube.</strong>
      <a href="https://policies.google.com/privacy?hl=fr" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité de YouTube
      </a><br />
      <a
        href="https://policies.google.com/technologies/cookies?hl=fr"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        YouTube
      </a>
      <br /><br />
      <strong> Google.</strong>
      <a href="https://policies.google.com/?hl=fr" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité Google
      </a><br />
      <a
        href="https://policies.google.com/technologies/cookies?hl=fr"
        target="_blank"
      >
        Cliquez ici pour obtenir des informations sur les cookies utilisés par
        Google
      </a>
      <br /><br />
      <strong>Linkedin.</strong>
      <a
        href="https://www.linkedin.com/legal/privacy-policy?_l=fr_FR"
        target="_blank"
      >
        Cliquez ici pour consulter la politique de confidentialité de Linkedin
      </a><br />
      <a href="https://www.linkedin.com/legal/cookie-policy" target="_blank">
        Cliquez ici pour consulter la politique de confidentialité cookies de
        Linkedin
      </a>
      <br />
    </span>
  {:else if displayBloc == 'cgu'}
    <span>
      Texte des <strong>cgu</strong>
    </span>
  {/if}
  <!-- {@html txt} -->
</span>

<style>
  .asLinkPdc {
    border-bottom: 1px solid black;
    cursor: pointer;
    transition: all 400ms;
  }
  .asLinkPdc:hover {
    border-bottom: 1px solid #0002;
  }
  span {
    font-family: 'introlight';
    font-size: 16px;
  }
  span strong {
    font-family: 'introblack';
  }
  .title3 {
    font-style: italic;
    color: #0009;
  }
</style>
